import EmbeddedMenuItem from './EmbeddedMenuItem';

export default EmbeddedMenuItem;
